{
  "title": "Message",
  "source": "Player's Handbook",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "120 feet",
  "components": "V, S, M (a short piece of copper wire)",
  "duration": "1 round",
  "description": [
    "You point your finger toward a creature within range and whisper a message. The target (and only the target) hears the message and can reply in a whisper that only you can hear.",
    "You can cast this spell through solid objects if you are familiar with the target and know it is beyond the barrier. Magical silence, 1 foot of stone, 1 inch of common metal, a thin sheet of lead, or 3 feet of wood blocks the spell. The spell doesn’t have to follow a straight line and can travel freely around corners or through openings."
  ],
  "spellLists": ["artificer", "bard", "eldritch-knight", "arcane-trickster", "sorcerer", "wizard"]
}
